import FromNow from './FromNow'

export default FromNow
